module.exports = __webpack_public_path__ + "img/team-member.b6b60fa1.svg";